import { ColorBloomTeal700, ColorBloomTeal100, ColorBloomYellow700, ColorBloomYellow100 } from '@treatwell/design-tokens';

const ColorPairTeal = {
    color: ColorBloomTeal700,
    backgroundColor: ColorBloomTeal100,
};
const ColorPairYellow = {
    color: ColorBloomYellow700,
    backgroundColor: ColorBloomYellow100,
};

export { ColorPairTeal, ColorPairYellow };
//# sourceMappingURL=colour-pair.js.map
